import { ROLE_ADMIN_USER } from '~/consts/roles';

import { isAdmin } from '~/utils/adminPermission';

import { OFFER_TYPES } from './constants';

export const CUSTOM_OFFER_PACKAGE_ADMIN_ROLES = [ROLE_ADMIN_USER] as const;

/** Minimal user shape for role checks (e.g. current agent from useCurrentUser). */
export type CustomOfferPackagePermissionUser = { roles?: Array<string> } | null | undefined;

const CUSTOM_OFFER_PACKAGE_ITEM_TYPE = 'custom-offer-package';

export function isCustomOfferPackageItemType(itemType: string | undefined): boolean {
  return itemType === CUSTOM_OFFER_PACKAGE_ITEM_TYPE;
}

export function getSelectableOfferTypesForUser(
  offerTypes: typeof OFFER_TYPES,
  user: CustomOfferPackagePermissionUser,
): typeof OFFER_TYPES {
  if (isAdmin(user)) {
    return offerTypes;
  }

  return offerTypes.filter((offerType) => offerType.value !== CUSTOM_OFFER_PACKAGE_ITEM_TYPE);
}

/** Includes package type for display when a non-admin edits an existing package offer. */
export function getOfferTypeSelectOptions(
  offerTypes: typeof OFFER_TYPES,
  user: CustomOfferPackagePermissionUser,
  currentItemType: App.CustomOfferType | undefined,
): typeof OFFER_TYPES {
  const selectableOfferTypes = getSelectableOfferTypesForUser(offerTypes, user);

  if (
    isCustomOfferPackageItemType(currentItemType) &&
    !isAdmin(user) &&
    !selectableOfferTypes.some((offerType) => offerType.value === CUSTOM_OFFER_PACKAGE_ITEM_TYPE)
  ) {
    const packageOfferType =
      offerTypes.find((offerType) => offerType.value === CUSTOM_OFFER_PACKAGE_ITEM_TYPE) ??
      OFFER_TYPES.find((offerType) => offerType.value === CUSTOM_OFFER_PACKAGE_ITEM_TYPE);

    return packageOfferType ? [...selectableOfferTypes, packageOfferType] : selectableOfferTypes;
  }

  return selectableOfferTypes;
}

export function isOfferTypeSelectLocked(
  user: CustomOfferPackagePermissionUser,
  currentItemType: App.CustomOfferType | undefined,
): boolean {
  return isCustomOfferPackageItemType(currentItemType) && !isAdmin(user);
}
